import Vue from "vue";
import Router from "vue-router";
import auth from "../middleware/auth";
import loginMiddleware from "../middleware/loginMiddleware";

// Contenedores
const TheContainer = () => import("@/containers/TheContainer");

/*PROVEEDORES*/
const Proveedores = () => import("@/views/proveedores/Index");
const PerfilProveedor = () => import("@/views/proveedores/Perfil");

// Views - Paginas
const Page404 = () => import("@/views/pages/errors/Page404");
const Login = () => import("@/views/pages/auth/Login");

Vue.use(Router);

let router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  base: process.env.NODE_ENV === 'production' ? '/proveedores' : '/',
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        middleware: [loginMiddleware]
      }
    },
    {
      path: "/",
      redirect: "/proveedores",
      name: "Inicio",
      component: TheContainer,
      children: [
        {
          path: 'proveedores',
          name: 'Proveedores',
          component: Proveedores,
          meta: {
            middleware: [auth] // Agrega el middleware a la ruta
          }
        },
        {
          path: 'proveedores/perfil',
          name: 'Proveedor',
          component: PerfilProveedor,
          meta: {
            middleware: [auth] // Agrega el middleware a la ruta
          }
        },
      ],
    },
    {
      path: "/:catchAll(.*)",
      component: Page404,
      name: "NotFound",
    },
  ];
}

router.beforeEach((to, from, next) => {
  if (from.path == to.path) {
    return
  }
  // Ejecuta los middlewares definidos en la meta de la ruta
  const middleware = to.meta.middleware;
  if (middleware) {
    // Recorre todos los middlewares definidos en la ruta
    middleware.forEach((middlewareFunction) => {
      middlewareFunction(to, from, next);
    });
  }

  return next();
});
export default router;
